const angular = require('angular');
const app = angular.module('learn-directives');
/**
 * Defines the Image Editor component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */

app.directive('avatarImage', [function () {
  return {
    restrict: 'A',
    replace: false,
    scope: {
      imageUrl: '=',
      modifiedUrl: '=',
      inputId: '@',
      editorState: '='
    },
    link: function (scope, element, attrs) {
      if (window.Aviary && window.Aviary.launchData) {
        window.Aviary.launchData.forceCropPreset = [["", "1:1"]];
        window.Aviary.launchData.cropPresets = [["", "1:1"]];
        window.Aviary.launchData.initTool = "forcecrop";
        window.Aviary.launchData.forceCropMessage = "Please adjust your image size";
        if (scope.editorState) {
          scope.editorState.available = true;
        }
      }
      var avatarAviary = {};
      var reset = true;
      window.setTimeout(function() {
        avatarAviary.input = document.getElementById(scope.inputId);
        var options = {
          apiKey: '75bfa8a0-99d6-4396-85f6-882c32d2a988',
          theme: "minimum",
          tools: ["effects"],
          cropPresets: [["", "1:1"]],
          onLoad: function() {
            if (scope.editorState) {
              scope.editorState.available = true;
            }
          },
          onSave: function(imageID, newURL) {
            avatarAviary.input.src = newURL;
            scope.modifiedUrl = newURL;
            scope.$apply();
            reset = false;
            avatarAviary.featherEditor.close();
          },
          onError: function(errorObj) {
            alert(errorObj.message);
          },
          onClose: function(isDirty) {
            if (reset) {
              scope.modifiedUrl = 'reset';
              scope.$apply();
            }
          }
        };

        avatarAviary.featherEditor = new Aviary.Feather(options);

        avatarAviary.launchEditor = function(id, src) {
          var launchOptions = {
            image: id,
            url: src,
            forceCropPreset: ["", "1:1"],
            forceCropMessage: "Please adjust your image size"
          };
          this.featherEditor.launch(launchOptions);
          return false;
        };

        element.bind('click', function(e) {
          e.preventDefault();
          avatarAviary.input.src = scope.imageUrl;
          avatarAviary.launchEditor(scope.inputId, avatarAviary.input.src);
        });
      });      
    }
  }
}]);
